import React, { useState } from "react";
import {
  MenuOutlined,
  CloseOutlined,
  HistoryOutlined,
  WalletOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";

import { signOut } from "../../common/session";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleSignOut = () => {
    signOut();
    setIsOpen(false);
    navigate("/login");
  };

  return (
    <div>
      <button
        onClick={toggleMenu}
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          background: "#ffffff",
          border: "1px solid #f1f5f9",
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.08)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "18px",
          color: "#0f172a",
          cursor: "pointer",
          transition: "all 0.2s ease",
        }}
        aria-label="Open menu"
      >
        <MenuOutlined />
      </button>

      {isOpen && (
        <div
          onClick={toggleMenu}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15, 23, 42, 0.6)",
            backdropFilter: "blur(4px)",
            zIndex: 9999,
            animation: "fadeIn 0.2s ease-out",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "280px",
              height: "100%",
              background: "#ffffff",
              boxShadow: "4px 0 25px rgba(0, 0, 0, 0.15)",
              display: "flex",
              flexDirection: "column",
              padding: "24px 20px",
              animation: "slideInLeft 0.25s cubic-bezier(0.16, 1, 0.3, 1)",
            }}
          >
            {/* Header */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                paddingBottom: "20px",
                borderBottom: "1px solid #f1f5f9",
                marginBottom: "20px",
              }}
            >
              <div>
                <h2
                  style={{
                    fontSize: "18px",
                    fontWeight: "800",
                    color: "#d9363e",
                    margin: 0,
                    letterSpacing: "-0.5px",
                  }}
                >
                  FOODOOR
                </h2>
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "#64748b",
                  }}
                >
                  Delivery Partner
                </span>
              </div>
              <button
                onClick={toggleMenu}
                style={{
                  background: "#f1f5f9",
                  border: "none",
                  borderRadius: "50%",
                  width: "32px",
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#64748b",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
                aria-label="Close menu"
              >
                <CloseOutlined />
              </button>
            </div>

            {/* Menu Links */}
            <div style={{ display: "flex", flexDirection: "column", gap: "10px", flex: 1 }}>
              <Link
                to="/order-history"
                onClick={toggleMenu}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "14px",
                  padding: "12px 14px",
                  borderRadius: "12px",
                  background: "#f8fafc",
                  color: "#0f172a",
                  transition: "background 0.2s",
                }}
              >
                <div
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "10px",
                    background: "#fee2e2",
                    color: "#d9363e",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "16px",
                  }}
                >
                  <HistoryOutlined />
                </div>
                <div>
                  <h4 style={{ margin: 0, fontSize: "14px", fontWeight: "600" }}>
                    Order History
                  </h4>
                  <p style={{ margin: 0, fontSize: "11px", color: "#64748b" }}>
                    Delivered orders & history
                  </p>
                </div>
              </Link>

              <Link
                to="/wallet"
                onClick={toggleMenu}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "14px",
                  padding: "12px 14px",
                  borderRadius: "12px",
                  background: "#f8fafc",
                  color: "#0f172a",
                  transition: "background 0.2s",
                }}
              >
                <div
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "10px",
                    background: "#dcfce7",
                    color: "#16a34a",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "16px",
                  }}
                >
                  <WalletOutlined />
                </div>
                <div>
                  <h4 style={{ margin: 0, fontSize: "14px", fontWeight: "600" }}>
                    My Wallet
                  </h4>
                  <p style={{ margin: 0, fontSize: "11px", color: "#64748b" }}>
                    Earnings & payouts
                  </p>
                </div>
              </Link>
            </div>

            {/* Logout Button */}
            <div style={{ paddingTop: "20px", borderTop: "1px solid #f1f5f9" }}>
              <button
                onClick={handleSignOut}
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                  padding: "12px",
                  borderRadius: "12px",
                  background: "#fff1f2",
                  color: "#e11d48",
                  border: "1px solid #ffe4e6",
                  fontSize: "14px",
                  fontWeight: "700",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
              >
                <LogoutOutlined />
                <span>Logout</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;
